import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Folder, ArrowLeftRight, UserCheck } from 'lucide-react';
import { useProjectContext } from '../../../contexts/ProjectContextProvider';
import { useModulePermissions } from '../../../auth/ModuleAccessContext';
import { ProjectSwitcherModal } from './ProjectSwitcherModal';
import TestProjektBadge, { arTestprojekt } from '../../TestProjektBadge';

export function ProjectContext() {
  const { currentProject, switchProject } = useProjectContext();
  const { modules, isAdmin } = useModulePermissions();
  const [switcherOpen, setSwitcherOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (!currentProject) return null;

  const inskrivningPath = `/projects/${currentProject.id}/inskrivning`;
  const onInskrivning = location.pathname.startsWith(inskrivningPath);
  const canSeeInskrivning = isAdmin || !modules || modules.has('p.inskrivningar');

  const numberStatusParts = [];
  if (currentProject.number) numberStatusParts.push(String(currentProject.number));
  if (currentProject.status) numberStatusParts.push(String(currentProject.status));
  const numberStatus = numberStatusParts.join(' · ');

  return (
    <>
      <div className="kp-project-context kp-project-context--active" aria-label="Aktuellt projekt">
        <div className="kp-project-context-row">
          <span className="kp-project-context-icon" aria-hidden="true">
            <Folder size={15} strokeWidth={2} />
          </span>
          <span className="kp-project-context-body">
            <span className="kp-project-context-name" title={currentProject.name}>
              {currentProject.name}
            </span>
            {numberStatus ? (
              <span className="kp-project-context-meta">{numberStatus}</span>
            ) : null}
          </span>
          {arTestprojekt(currentProject) ? <TestProjektBadge /> : null}
        </div>
        <div className="kp-project-context-actions">
          <button
            type="button"
            className="kp-project-context-btn"
            onClick={() => setSwitcherOpen(true)}
            aria-label="Byt projekt"
          >
            <ArrowLeftRight size={11} strokeWidth={2.5} aria-hidden="true" />
            Byt projekt
          </button>
          {canSeeInskrivning ? (
            <button
              type="button"
              className={'kp-project-context-btn' + (onInskrivning ? ' kp-project-context-btn--active' : '')}
              onClick={() => navigate(inskrivningPath)}
              aria-label="Inskrivning"
              aria-current={onInskrivning ? 'page' : undefined}
            >
              <UserCheck size={11} strokeWidth={2.5} aria-hidden="true" />
              Inskrivning
            </button>
          ) : null}
        </div>
      </div>
      {switcherOpen ? (
        <ProjectSwitcherModal
          onClose={() => setSwitcherOpen(false)}
          onSelect={(project) => {
            switchProject(project);
            setSwitcherOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
